import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeInitialQuoteAccessorials } from './normalize';

export const fetchInitialQuoteAccessorials = createProvider(api.fetchInitialQuoteAccessorials)
  .andThen((res) => normalizeInitialQuoteAccessorials(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch cached quote rate results aborted');
    } else {
      console.error('Fetch cached quote rate results failed:', error);
    }
    throw error;
  });
